export default function App({ children }) {
  return children;
}
